import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-16 px-4 sm:px-6 lg:px-8 bg-grid-pattern" data-id="element-48">
      {/* Background Effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-400/10 rounded-full blur-[120px] pointer-events-none" data-id="element-49" />
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-navy-950/80 via-transparent to-navy-900 pointer-events-none" data-id="element-50" />

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-51">
        <div className="text-center order-2 lg:order-1" data-id="element-52">
          <FadeIn delay={0.1} data-id="element-53">
            <div className="inline-block mb-4 px-3 py-1 rounded-full border border-gold-500/30 bg-gold-500/10 text-gold-400 text-xs font-semibold tracking-widest uppercase" data-id="element-54">
              Tecnología de la Conciencia
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-55">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.15] mb-6 drop-shadow-lg max-w-3xl mx-auto" data-id="element-56">
              DEJA DE SER FIEL
              <br className="hidden sm:block" data-id="element-57" /> A LA IGNORANCIA
              <span className="block mt-3 text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600 text-3xl sm:text-4xl lg:text-5xl" data-id="element-58">
                El Manual Para el Jugador Que Pactó Tu Realidad
              </span>
            </h1>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-59">
            <h2 className="text-lg sm:text-xl text-[#E2E6E9]/80 mb-10 leading-relaxed font-light max-w-2xl mx-auto" data-id="element-60">
              No tienes malas cartas. Tienes un manual que no habías leído. Es
              hora de activar al Operador de la Lattice y jugar la partida del
              equilibrio.
            </h2>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-61">
            <CTAButton onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-62">
              SÍ — QUIERO ACTIVAR AL OPERADOR
            </CTAButton>
          </FadeIn>
        </div>

        <div className="order-1 lg:order-2 flex justify-center relative" data-id="element-63">
          <FadeIn delay={0.5} direction="left" className="relative w-full max-w-md" data-id="element-64">
            {/* Image glow */}
            <div className="absolute inset-0 bg-gold-500/20 blur-[60px] rounded-full transform scale-90" data-id="element-65" />
            <img src="https://cdn.magicpatterns.com/uploads/k8p8CuRCsVH1AcByAS9i7j/Mockup.png" alt="Operador de la Lattice - Código Silente" className="relative z-10 w-full h-auto drop-shadow-2xl animate-[float_6s_ease-in-out_infinite]" data-id="element-66" />
          </FadeIn>
        </div>
      </div>
    </section>;
}